function syncAnnouncementBarOffsets(announcementBar, header, isStickyBanner, isHeaderSticky, menuMobile) {
    if (!announcementBar) {
        return;
    }

    const announcementBarHeight = announcementBar.getBoundingClientRect().height;
    const announcementSpace = isStickyBanner ? announcementBarHeight : (isHeaderSticky ? 0 : announcementBarHeight);

    announcementBar.style.setProperty('--announcement-bar-offset', `${announcementSpace}px`);
    announcementBar.style.setProperty('--announcement-bar-offset-mobile', `${announcementSpace / 16}rem`);
    header?.style.setProperty('--announcement-bar-offset', `${announcementSpace}px`);
    header?.style.setProperty('--announcement-bar-offset-mobile', `${announcementSpace / 16}rem`);

    if (menuMobile) {
        menuMobile.style.setProperty('--announcement-bar-offset-mobile', `${announcementSpace / 16}rem`);
    }
}

class Header {
    constructor() {
        this.body = document.querySelector('body');
        this.header = document.getElementById('shopify-section-header');
        this.announcementBar = document.getElementById('shopify-section-announcement-bar');
        this.announcementBarInner = this.announcementBar?.querySelector('[id^="AnnouncementBar-"]');
        this.toggleMenuMobileButton = document.querySelector('button[data-toggle-mobile-menu]');
        this.menuMobile = document.querySelector('[data-mobile-menu]');
        this.toggleMobileSubMenus = document.querySelectorAll('button[data-menu-sub-item]');
        this.closeMobileSubMenus = document.querySelectorAll('button[data-close-sub-menu]');
        this.mobileSubMenuAccordions = document.querySelectorAll('[data-sub-menu-accordion-context]');
        this.toggleDesktopSubMenus = document.querySelectorAll('button[data-header-toggle-menu]');
        this.desktopSubMenus = document.querySelectorAll('[data-header-sub-menu]');
        this.announcementBarSticky = this.announcementBarInner?.dataset.announcementBarSticky === 'true';
        this.divider = document.querySelector('[data-header-divider]');

        this.predictiveSearch = document.querySelector('predictive-search');
        this.predictiveSearchModal = document.querySelector('modal-dialog[id=PredictiveSearch]');
        this.predictiveSearchToggleButton = document.querySelector('modal-opener[data-modal="#PredictiveSearch"] button');
        this.predictiveSearchInput = document.querySelector('#Search-In-Modal');

        this.desktopBreakpoint = 1280;
        this.announcementBarResizeObserver = null;

        this.menuEventListeners();

        this.announcementBarCheck();
    }

    setAnnouncementBarStickyClasses () {
        if (!this.announcementBar) {
            return;
        }

        this.announcementBar.classList.toggle('sticky', this.announcementBarSticky);
        this.announcementBar.classList.toggle('top-0', this.announcementBarSticky);
        this.announcementBar.classList.toggle('z-40', this.announcementBarSticky);
    }

    menuEventListeners () {
        this.toggleMenuMobileButton.addEventListener('click', () => {
            this.toggleMobileMenu(this.menuMobile);
            this.toggleMobileBodyOverflow();
            this.animateMobileIcon();
        })

        this.toggleMobileSubMenus.forEach(toggle => {
            toggle.addEventListener('click', (event) => {
                if (window.innerWidth < this.desktopBreakpoint) {
                    const menu = event.target.nextElementSibling;
                    this.toggleMobileMenu(menu);
                }
            })
        })

        this.closeMobileSubMenus.forEach(close => {
            close.addEventListener('click', (event) => {
                const menu = event.target.closest('div[data-sub-menu]');
                this.toggleMobileMenu(menu);
            })
        })

        this.mobileSubMenuAccordions.forEach(mobileSubMenuAccordion => {
            const trigger = mobileSubMenuAccordion.querySelector('[data-sub-menu-accordion-trigger]');

            trigger.addEventListener('click', () => {
                trigger.querySelector('[data-sub-menu-accordion-trigger-icon]').classList.toggle('is-active');
                mobileSubMenuAccordion.querySelector('[data-sub-menu-accordion-content').classList.toggle('is-active');
            });
        })

        this.toggleDesktopSubMenus.forEach(button => {
            button.addEventListener('click', (event) => {
                if (window.innerWidth >= this.desktopBreakpoint) {
                    const menu = event.target.nextElementSibling;
                    this.toggleDesktopSubMenu(menu, event);
                }
            })
        })

        if (this.predictiveSearchToggleButton) {
            this.predictiveSearchToggleButton.addEventListener('click', () => {
                window.requestAnimationFrame(() => {
                    if (this.predictiveSearchModal?.classList.contains('is-active')) {
                        this.predictiveSearchInput?.focus();
                    }
                });
            });
        }
    }

    toggleMobileMenu (menu) {
        if (this.announcementBar && this.announcementBarInner) {
            syncAnnouncementBarOffsets(this.announcementBarInner, this.header, this.announcementBarSticky, document.body.classList.contains('header-is-sticky'), this.menuMobile);
        }

        if (menu.classList.contains('xLargeMax:translate-x-0')) {
            menu.classList.remove('xLargeMax:translate-x-0');
            menu.classList.add('xLargeMax:-translate-x-full');
            if (menu.hasAttribute('data-sub-menu')) {
                menu.querySelector('[data-close-sub-menu]').setAttribute('aria-expanded', false);
            }
        } else {
            menu.classList.add('xLargeMax:translate-x-0');
            menu.classList.remove('xLargeMax:-translate-x-full');
            if (menu.hasAttribute('data-sub-menu')) {
                menu.querySelector('[data-close-sub-menu]').setAttribute('aria-expanded', true);
            }
        }
    }

    toggleMobileBodyOverflow () {
        if (this.menuMobile.classList.contains('xLargeMax:translate-x-0')) {
            this.body.classList.add('xLargeMax:overflow-hidden');
        } else {
            this.body.classList.remove('xLargeMax:overflow-hidden');
        }
    }

    animateMobileIcon () {
        const top = document.querySelector('.js-mobile-menu-top');
        const mid = document.querySelector('.js-mobile-menu-mid');
        const btm = document.querySelector('.js-mobile-menu-btm');

        if (this.toggleMenuMobileButton.classList.contains('xLargeMax:z-60')) {
            this.toggleMenuMobileButton.classList.remove('xLargeMax:z-60', 'xLargeMax:w-[1.625rem]', 'xLargeMax:translate-x-[0.4375rem]');
            top.classList.remove('xLargeMax:rotate-45');
            top.classList.remove('xLargeMax:top-1/2');
            mid.classList.remove('xLargeMax:opacity-0');
            btm.classList.remove('xLargeMax:-rotate-45');
            btm.classList.remove('xLargeMax:top-1/2');
        } else {
            this.toggleMenuMobileButton.classList.add('xLargeMax:z-60', 'xLargeMax:w-[1.625rem]', 'xLargeMax:translate-x-[0.4375rem]');
            top.classList.add('xLargeMax:rotate-45');
            top.classList.add('xLargeMax:top-1/2');
            mid.classList.add('xLargeMax:opacity-0');
            btm.classList.add('xLargeMax:-rotate-45');
            btm.classList.add('xLargeMax:top-1/2');
        }
    }

    toggleDesktopSubMenu (menu, button) {
        const svg = button.target.querySelector('[data-desktop-menu-caret]');
        const isTopLevelLink = button.target.dataset.headerTopLevel;
        if (menu.classList.contains('xLarge:opacity-0')) {
            if (isTopLevelLink) {
                this.closeAllDesktopSubMenus();
            }
            menu.classList.remove('xLarge:opacity-0');
            menu.classList.remove('xLarge:invisible');
            menu.classList.remove('xLarge:h-0');
            svg.classList.add('xLarge:rotate-180');
            menu.closest('[data-sub-menu]').setAttribute('aria-expanded', true);
            this.divider?.classList.remove('xLarge:hidden');
        } else {
            menu.classList.add('xLarge:opacity-0');
            menu.classList.add('xLarge:invisible');
            menu.classList.add('xLarge:h-0');
            svg.classList.remove('xLarge:rotate-180');
            menu.closest('[data-sub-menu]').setAttribute('aria-expanded', false);
            this.divider?.classList.add('xLarge:hidden');
        }
    }

    closeAllDesktopSubMenus () {
        this.desktopSubMenus.forEach(menu => {
            if (!menu.classList.contains('xLarge:opacity-0')) {
                menu.classList.add('xLarge:opacity-0');
                menu.classList.add('xLarge:invisible');
                menu.classList.add('xLarge:h-0');
            }
        })

        this.toggleDesktopSubMenus.forEach(button => {
            const svg = button.querySelector('[data-desktop-menu-caret]');
            if (svg.classList.contains('xLarge:rotate-180')) {
                svg.classList.remove('xLarge:rotate-180');
            }
        })
    }

    announcementBarCheck () {
        if (this.announcementBar && this.announcementBarInner) {
            this.setAnnouncementBarStickyClasses();
            syncAnnouncementBarOffsets(this.announcementBarInner, this.header, this.announcementBarSticky, document.body.classList.contains('header-is-sticky'), this.menuMobile);

            if (typeof ResizeObserver !== 'undefined' && !this.announcementBarResizeObserver) {
                this.announcementBarResizeObserver = new ResizeObserver(() => {
                    syncAnnouncementBarOffsets(this.announcementBarInner, this.header, this.announcementBarSticky, document.body.classList.contains('header-is-sticky'), this.menuMobile);
                });

                this.announcementBarResizeObserver.observe(this.announcementBarInner);
            }

            // Adds additional padding to mobile sub menus
            document.querySelectorAll('div[data-sub-menu]').forEach(menu => {
                if (menu) {
                    menu.classList.add('xLargeMax:pt-[4.375rem]');
                }
            });
        }
    }
}

export default class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.announcementBar = document.getElementById('shopify-section-announcement-bar');
        this.announcementBarInner = this.announcementBar?.querySelector('[id^="AnnouncementBar-"]');
        this.announcementBarSticky = this.announcementBarInner?.dataset.announcementBarSticky === 'true';
        this.headerBounds = {};

        this.currentScrollTop = 0;
        this.preventReveal = false;

        this.predictiveSearch = this.querySelector('predictive-search');
        this.predictiveSearchModal = this.querySelector('modal-dialog[id=PredictiveSearch]');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        syncAnnouncementBarOffsets(this.announcementBarInner, this.header, this.announcementBarSticky, false);
        this.createObserver();
    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        // Skip all sticky header logic if mobile menu is open
        const mobileMenu = document.querySelector('[data-mobile-menu]');
        if (mobileMenu && mobileMenu.classList.contains('xLargeMax:translate-x-0')) {
            return;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearchModal && this.predictiveSearchModal.classList.contains('is-active')) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            window.requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (!this.preventReveal) {
                window.requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                window.requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            window.requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.header.classList.add('-translate-y-full', 'overflow-hidden', 'sticky', 'top-[var(--announcement-bar-offset,0px)]', 'z-20');
        this.closeMenuDisclosure();
        syncAnnouncementBarOffsets(this.announcementBarInner, this.header, this.announcementBarSticky, true);
        document.body.classList.remove('header-is-sticky');
    }

    reveal() {
        this.header.classList.add('header-is-sticky', 'sticky', 'top-[var(--announcement-bar-offset,0px)]', 'z-20', 'transition-[transform_0.15s_ease-out]');
        this.header.classList.remove('-translate-y-full', 'overflow-hidden');
        syncAnnouncementBarOffsets(this.announcementBarInner, this.header, this.announcementBarSticky, true);
        document.body.classList.add('header-is-sticky');
    }

    reset() {
        this.header.classList.remove('header-is-sticky', '-translate-y-full', 'overflow-hidden', 'sticky', 'top-[var(--announcement-bar-offset,0px)]', 'z-20', 'transition-[transform_0.15s_ease-out]');
        syncAnnouncementBarOffsets(this.announcementBarInner, this.header, this.announcementBarSticky, false);
        document.body.classList.remove('header-is-sticky');
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
    }
}

export {
    Header,
    StickyHeader
}
